import { canonicalJson } from './canonical-json.js';

/**
 * SHA-256 über die Web-Crypto-API. Identisch verfügbar im Browser und in
 * Node 22 (Lambda) — dieselbe Funktion erzeugt auf beiden Seiten denselben
 * Hash, was für die Rendering-Parität Voraussetzung ist.
 */
export const sha256Hex = async (eingabe: string): Promise<string> => {
  const bytes = new TextEncoder().encode(eingabe);
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
};

/**
 * Der `dataHash` eines Protokolls: kanonisches JSON der Protokolldaten,
 * anschließend SHA-256. Genau dieser Wert wird von den Signaturen bezeugt.
 */
export const berechneDataHash = async (data: unknown): Promise<string> =>
  sha256Hex(canonicalJson(data));

/** Kurzform für Anzeige und PDF-Fußzeile: die ersten 12 Zeichen. */
export const hashPraefix = (dataHash: string, laenge = 12): string =>
  dataHash.slice(0, laenge).toLowerCase();

/**
 * Zeitkonstanter Vergleich zweier Hex-Hashes. Verhindert, dass sich ein
 * gültiger Token/Hash über Laufzeitunterschiede erraten lässt.
 */
export const hashGleich = (a: string, b: string): boolean => {
  if (a.length !== b.length) return false;
  let unterschied = 0;
  for (let i = 0; i < a.length; i += 1) {
    unterschied |= a.charCodeAt(i) ^ b.charCodeAt(i);
  }
  return unterschied === 0;
};
